import { usePreferences, useUpdatePreferences } from '@/features/preferences'

export interface IslandSettings {
  enabled: boolean
  weather: boolean
  osNotifications: boolean
  aiFacts: boolean
  sounds: boolean
  briefs: boolean
  /** Where the person dragged it (fractions of the viewport); null = automatic placement. */
  position: { x: number; y: number } | null
}

/** On by default; desktop notifications stay off until the person turns them on (and grants). */
export const DEFAULT_ISLAND: IslandSettings = { enabled: true, weather: true, osNotifications: false, aiFacts: true, sounds: true, briefs: true, position: null }

export function useIslandSettings() {
  const prefs = usePreferences()
  const update = useUpdatePreferences()
  const settings: IslandSettings = { ...DEFAULT_ISLAND, ...(prefs.data?.dynamicIsland ?? {}) }
  return {
    settings,
    loaded: prefs.isSuccess || prefs.isError,
    save: (patch: Partial<IslandSettings>) => update.mutateAsync({ dynamicIsland: { ...settings, ...patch } }),
    saving: update.isPending,
  }
}
